export const environment = {
  production: false,
  recaptcha_site_key: '6LdmRHsjAAAAAIGNPPbnX03JXBuILltr9kB66ZOA',
  api_url: 'https://paxi-email-proxy-m2d4u4fhnq-ew.a.run.app/email/send',
};
